import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Hans Böhm
 * id 0FA06948-5C0F-498D-BDCD-15EB208057F9
 * name content-save-minus
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/content-save-minus.svg
 * tags
 */
export const ContentSaveMinusIcon = createSvgIcon(<><path d="M17 3H5C3.89 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H12.81C12.45 20.38 12.2 19.7 12.08 19L12 19C10.34 19 9 17.66 9 16S10.34 13 12 13C12.68 13 13.34 13.23 13.87 13.65C15 12.59 16.46 12 18 12C19.05 12 20.09 12.28 21 12.81V7L17 3M15 9H5V5H15V9M14 17V19H22V17H14Z" /></>, 'ContentSaveMinusIcon');
export default ContentSaveMinusIcon